import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CommercialAtacadoService } from '../commercial-atacado-service/commercial-atacado.service';
import { ConversaoLibraConverte } from './../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { Parametro } from './../../../../shared/service-base/parametro';


@Component({
  selector: 'app-commercial-atacado-lista',
  templateUrl: './commercial-atacado-lista.component.html',
  styleUrls: ['./commercial-atacado-lista.component.css']
})
export class CommercialAtacadoListaComponent extends ListaBase implements OnInit {

  colsTable1: any[];
  colsTable2: any[]
  colsQuarters: any[];
  colsHistory: any[];
  _selectedColumns: any[];
  _selectedColumnsTitle: any[];
  rowColorRed: any
  loading: boolean;
  parametrosFiltro: any;
  filtroconsolidado = false;
  filtropecas = true;
  filtroroupas = true;
  filtroacessorios = true;
  titulo = 'PCA-CONSOLIDADO';
  ano: any;
  tipo: any;
  comercialAtacado: any;
  comercialAtacadoTab2: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  nome_dealer: any;
  budget = 0;
  budget_ytd = 0;
  realizado = 0;
  pendente = 0;
  pendente_ytd = 0;
  q1_previsao = 0;
  q1_realizado = 0;
  q1_percentual = 0;
  q2_previsao = 0;
  q2_realizado = 0;
  q2_percentual = 0;
  q3_previsao = 0;
  q3_realizado = 0;
  q3_percentual = 0;
  q4_previsao = 0;
  q4_realizado = 0;
  q4_percentual = 0;
  budgetTab2 = 0;
  budgetTab2_mtd = 0;
  realizadoTab2 = 0;
  gap_mes = 0;
  gap_mes_mtd = 0;
  jul = 0;
  ago = 0;
  sete = 0;
  outr = 0;
  nov = 0;
  dez = 0;
  jan = 0;
  fev = 0;
  mar = 0;
  abr = 0;
  mai = 0;
  jun = 0;
  dadosTranslate = {
    "Brasil": "commercial.commercialAtacado.abaPrincipal.brasil",
    "PCA-CONSOLIDADO": "commercial.commercialAtacado.abaPrincipal.tituloPcaConsolidado",
    "PEÇAS": "commercial.commercialAtacado.abaPrincipal.tituloPecas",
    "ROUPAS": "commercial.commercialAtacado.abaPrincipal.tituloRoupas",
    "ACESSÓRIOS": "commercial.commercialAtacado.abaPrincipal.tituloAcessorios",
    "Calculando...": "commercial.commercialAtacado.calculando",
  }

  arrayTranslate = [{ categoria: "Calculando...", chave: "commercial.commercialAtacado.calculando" }];

  subscription;

  constructor(service: CommercialAtacadoService,
    toastr: ToastrService,
    router: Router,
    private comercialAtacadoService: CommercialAtacadoService,
    private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private currency: CurrencyPipe,
    private percent: PercentPipe) {
    super(service, toastr, router);
    this.nomeModulo = 'commercial-atacado';
  }


  ngOnInit(): void {
    this.TableColumns();
    this.tipo = [1, 2, 3];
    this.setaValorData(null);
    this.calculando();
    this.calculandotab2();
    this.buscar();
    this.buscarTab2();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscar();
        this.buscarTab2();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setaValorData(ano: any) {
    if (ano === undefined || ano === null) {
      var data = new Date();
      var mes = String(data.getMonth() + 1).padStart(2, '0')
      if (parseInt(mes) >= 7) {
        this.ano = this.anoAtual.getFullYear() + 1;
      } else {
        this.ano = this.anoAtual.getFullYear();
      }
    } else {
      this.ano = ano;
    }
    this.filtros = { ano: this.ano, tipo: this.tipo };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {

          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.data_inicial
      || this.filtros.data_final;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }

  calculandoTranslate() {
    this.translate.onLangChange.subscribe((event: TranslationChangeEvent) => {

      if (event.lang == 'gb') {

      }
    });
  }

  buscar() {
    let objFiltro: Filtros = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    //setar
    this.comercialAtacadoService.setURL('/comercial_atacado');
    //chamar ela
    this.loading = true
    this.service.buscar(objFiltro).then(res => {
      res.dados.forEach(dados => {
        dados.budget = this.conversaoLibraConverte.conversaoLibra(dados.budget, null, null);
        dados.budget_ytd = this.conversaoLibraConverte.conversaoLibra(dados.budget_ytd, null, null);
        dados.pendente = this.conversaoLibraConverte.conversaoLibra(dados.pendente, null, null);
        dados.pendente_ytd = this.conversaoLibraConverte.conversaoLibra(dados.pendente_ytd, null, null);
        dados.q1_previsao = this.conversaoLibraConverte.conversaoLibra(dados.q1_previsao, null, null);
        dados.q1_realizado = this.conversaoLibraConverte.conversaoLibra(dados.q1_realizado, null, null);
        dados.q1_result = this.conversaoLibraConverte.conversaoLibra(dados.q1_result, null, null);
        dados.q2_previsao = this.conversaoLibraConverte.conversaoLibra(dados.q2_previsao, null, null);
        dados.q2_realizado = this.conversaoLibraConverte.conversaoLibra(dados.q2_realizado, null, null);
        dados.q3_previsao = this.conversaoLibraConverte.conversaoLibra(dados.q3_previsao, null, null);
        dados.q3_realizado = this.conversaoLibraConverte.conversaoLibra(dados.q3_realizado, null, null);
        dados.q4_previsao = this.conversaoLibraConverte.conversaoLibra(dados.q4_previsao, null, null);
        dados.q4_realizado = this.conversaoLibraConverte.conversaoLibra(dados.q4_realizado, null, null);
        dados.realizado = this.conversaoLibraConverte.conversaoLibra(dados.realizado, null, null);

      });
      this.comercialAtacado = res;
      this.calculandoTotalTab1(res);
      this.loading = false
    });
  }

  buscarTab2() {
    let objFiltro: Filtros = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.loading = true
    this.comercialAtacadoService.setURL('/comercial_atacado_tab2');
    this.service.buscar(objFiltro).then(res => {
      res.dados.forEach(dados => {
        dados.abr = this.conversaoLibraConverte.conversaoLibra(dados.abr, null, null);
        dados.ago = this.conversaoLibraConverte.conversaoLibra(dados.ago, null, null);
        dados.budget = this.conversaoLibraConverte.conversaoLibra(dados.budget, null, null);
        dados.budget_mtd = this.conversaoLibraConverte.conversaoLibra(dados.budget_mtd, null, null);
        dados.dez = this.conversaoLibraConverte.conversaoLibra(dados.dez, null, null);
        dados.fev = this.conversaoLibraConverte.conversaoLibra(dados.fev, null, null);
        dados.gap_mes = this.conversaoLibraConverte.conversaoLibra(dados.gap_mes, null, null);
        dados.gap_mes_mtd = this.conversaoLibraConverte.conversaoLibra(dados.gap_mes_mtd, null, null);
        dados.jan = this.conversaoLibraConverte.conversaoLibra(dados.jan, null, null);
        dados.jul = this.conversaoLibraConverte.conversaoLibra(dados.jul, null, null);
        dados.jun = this.conversaoLibraConverte.conversaoLibra(dados.jun, null, null);
        dados.mai = this.conversaoLibraConverte.conversaoLibra(dados.mai, null, null);
        dados.mar = this.conversaoLibraConverte.conversaoLibra(dados.mar, null, null);
        dados.nov = this.conversaoLibraConverte.conversaoLibra(dados.nov, null, null);
        dados.outr = this.conversaoLibraConverte.conversaoLibra(dados.outr, null, null);
        dados.sete = this.conversaoLibraConverte.conversaoLibra(dados.sete, null, null);
        dados.valor = this.conversaoLibraConverte.conversaoLibra(dados.valor, null, null);
      });

      this.comercialAtacadoTab2 = res;
      this.calculandoTotalTab2(res);
      this.loading = false
      // for (let dados of res?.dados) {
      //   var currentTime = new Date();
      //   var year = currentTime.getFullYear();
      //   if ((dados.jul || dados.jul == false) && this.filtros.ano != year + 1) {
      //     dados.valor = 0;
      //   }
      //   if ((dados.gap_mes || dados.gap_mes == false) && this.filtros.ano != year + 1) {
      //     dados.gap_mes = 0;
      //   }
      //   if ((dados.gap_mes_mtd || dados.gap_mes_mtd == false) && this.filtros.ano != year + 1) {
      //     dados.gap_mes_mtd = 0;
      //   }
      //   if ((dados.budget || dados.budget == false) && this.filtros.ano != year + 1) {
      //     dados.budget = 0;
      //   }
      //   if ((dados.budget_mtd || dados.budget_mtd == false) && this.filtros.ano != year + 1) {
      //     dados.budget_mtd = 0;
      //   }
      // }
    });
  }

  getColor(index: any): string {
    let menor: string = "#FF0000";

    if (index < 0) {
      return menor;
    }
  }
  getColorq(index: any): string {
    let menor: string = "#FF0000";

    if (index < 1) {
      return menor;
    }
  }

  calculandoTotalTab1(res) {
    this.nome_dealer = "Brasil";
    this.budget = res.totalBudgetFull
    this.budget_ytd = res.totalBudgetYtd
    this.realizado = res.totalRealizado;
    this.pendente = res.totalPendenteFull;
    this.pendente_ytd = res.totalPendenteYtd;
    this.q1_previsao = res.totalQ1Previsao;
    this.q1_realizado = res.totalQ1Realizado;
    this.q1_percentual = res.totalQ1Percentual
    this.q2_previsao = res.totalQ2Previsao;
    this.q2_realizado = res.totalQ2Realizado;
    this.q2_percentual = res.totalQ2Percentual
    this.q3_previsao = res.totalQ3Previsao;
    this.q3_realizado = res.totalQ3Realizado;
    this.q3_percentual = res.totalQ3Percentual;
    this.q4_previsao = res.totalQ4Previsao;
    this.q4_realizado = res.totalQ4Realizado;
    this.q4_percentual = res.totalQ4Percentual;

  }


  calculandoTotalTab2(res) {
    this.nome_dealer = "Brasil";
    this.budgetTab2 = res.totalBudgetFull;
    this.budgetTab2_mtd = res.totalBudgetMtd;
    this.realizadoTab2 = res.totalRealizado;
    this.gap_mes = res.totalGapMesFull;
    this.gap_mes_mtd = res.totalGapMesMtd;
    this.jul = res.totalJulho;
    this.ago = res.totalAgosto;
    this.sete = res.totalSetembro;
    this.outr = res.totalOutubro;
    this.nov = res.totalNovembro;
    this.dez = res.totalDezembro;
    this.jan = res.totalJaneiro;
    this.fev = res.totalFevereiro;
    this.mar = res.totalMarco;
    this.abr = res.totalAbril;
    this.mai = res.totalMaio;
    this.jun = res.totalJunho;


    // var currentTime = new Date();
    // var year = currentTime.getFullYear();
    // if ((res.totalJulho || res.totalJulho == false) && this.filtros.ano != year + 1) {
    //   this.realizadoTab2 = 0;
    // }
    // if ((res.totalGapMesFull || res.totalGapMesFull == false) && this.filtros.ano != year + 1) {
    //   this.gap_mes = 0;
    // }
    // if ((res.totalGapMesMtd || res.totalGapMesMtd == false) && this.filtros.ano != year + 1) {
    //   this.gap_mes_mtd = 0;
    // }
    // if ((res.totalBudgetFull || res.totalBudgetFull == false) && this.filtros.ano != year + 1) {
    //   this.budgetTab2 = 0;
    // }
    // if ((res.totalBudgetFullMtd || res.totalBudgetFullMtd == false) && this.filtros.ano != year + 1) {
    //   this.budgetTab2_mtd = 0;
    // }

  }

  consolidado() {
    this.filtroconsolidado = false;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = [1, 2, 3];
    this.calculando()
    this.calculandotab2()
    this.titulo = 'PCA-CONSOLIDADO';
    this.setaValorData(this.ano);
    this.buscar();
    this.buscarTab2();
  }

  pecas() {
    this.filtroconsolidado = true;
    this.filtropecas = false;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = 3;
    this.calculando()
    this.calculandotab2()
    this.titulo = 'PEÇAS';
    this.setaValorData(this.ano);
    this.buscar();
    this.buscarTab2();
  }

  roupas() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = false;
    this.filtroacessorios = true;
    this.tipo = 2;
    this.titulo = 'ROUPAS';
    this.calculando()
    this.calculandotab2()
    this.setaValorData(this.ano);
    this.buscar();
    this.buscarTab2();
  }

  acessorios() {
    this.filtroconsolidado = true;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = false;
    this.tipo = 1;
    this.titulo = 'ACESSÓRIOS';
    this.calculando()
    this.calculandotab2()
    this.setaValorData(this.ano);
    this.buscar();
    this.buscarTab2();
  }


  ngAfterViewChecked() {
  }

  calculando() {
    this.comercialAtacado = {
      dados: [
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0,
          "budget_ytd": 0,
          "realizado": 0.0,
          "pendente": 0.0,
          "pendente_ytd": 0.0,
          "qurters_q1": 0.0,
          "qurters_realizado_q1": 0.0,
          "qurters_percentual_q1": 0.0,
          "qurters_q2": 0.0,
          "qurters_realizado_q2": 0.0,
          "qurters_percentual_q2": 0.0,
          "qurters_q3": 0.0,
          "qurters_realizado_q3": 0.0,
          "qurters_percentual_q3": 0.0,
          "qurters_q4": 0.0,
          "qurters_realizado_q4": 0.0,
          "qurters_percentual_q4": 0.0,
        },
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0,
          "budget_ytd": 0,
          "realizado": 0.0,
          "pendente": 0.0,
          "pendente_ytd": 0.0,
          "qurters_q1": 0.0,
          "qurters_realizado_q1": 0.0,
          "qurters_percentual_q1": 0.0,
          "qurters_q2": 0.0,
          "qurters_realizado_q2": 0.0,
          "qurters_percentual_q2": 0.0,
          "qurters_q3": 0.0,
          "qurters_realizado_q3": 0.0,
          "qurters_percentual_q3": 0.0,
          "qurters_q4": 0.0,
          "qurters_realizado_q4": 0.0,
          "qurters_percentual_q4": 0.0,
        },
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0,
          "budget_ytd": 0,
          "realizado": 0.0,
          "pendente": 0.0,
          "pendente_ytd": 0.0,
          "qurters_q1": 0.0,
          "qurters_realizado_q1": 0.0,
          "qurters_percentual_q1": 0.0,
          "qurters_q2": 0.0,
          "qurters_realizado_q2": 0.0,
          "qurters_percentual_q2": 0.0,
          "qurters_q3": 0.0,
          "qurters_realizado_q3": 0.0,
          "qurters_percentual_q3": 0.0,
          "qurters_q4": 0.0,
          "qurters_realizado_q4": 0.0,
          "qurters_percentual_q4": 0.0,
        }

      ],
      total: [
        {
          "nome_dealer": "Calculando...",
          "qnt_dealer": 0,
          "budget": 0.0,
          "budget_ytd": 0,
          "realizado": 0.0,
          "pendente": 0.0,
          "pendente_ytd": 0.0
        }
      ]
    };

    this.budget = 0;
    this.budget_ytd = 0;
    this.realizado = 0;
    this.pendente = 0;
    this.pendente_ytd = 0;
    this.q1_previsao = 0;
    this.q1_realizado = 0;
    this.q1_percentual = 0;
    this.q2_previsao = 0;
    this.q2_realizado = 0;
    this.q2_percentual = 0;
    this.q3_previsao = 0;
    this.q3_realizado = 0;
    this.q3_percentual = 0;
    this.q4_previsao = 0;
    this.q4_realizado = 0;
    this.q4_percentual = 0;

  }
  calculandotab2() {
    this.comercialAtacadoTab2 = {
      dados: [
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0.0,
          "budget_mtd": 0.0,
          "valor": 0.0,
          "gap_mes": 0.0,
          "gap_mes_mtd": 0.0,
          "jul": 0.0,
          "ago": 0.0,
          "sete": 0.0,
          "outr": 0.0,
          "nov": 0.0,
          "dez": 0.0,
          "jan": 0.0,
          "fev": 0.0,
          "mar": 0.0,
          "abr": 0.0,
          "mai": 0.0,
          "jun": 0.0
        },
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0.0,
          "budget_mtd": 0.0,
          "valor": 0.0,
          "gap_mes": 0.0,
          "gap_mes_mtd": 0.0,
          "jul": 0.0,
          "ago": 0.0,
          "sete": 0.0,
          "outr": 0.0,
          "nov": 0.0,
          "dez": 0.0,
          "jan": 0.0,
          "fev": 0.0,
          "mar": 0.0,
          "abr": 0.0,
          "mai": 0.0,
          "jun": 0.0
        },
        {
          "codigo_dealer": "Calculando...",
          "nome_dealer": "Calculando...",
          "budget": 0.0,
          "budget_mtd": 0.0,
          "valor": 0.0,
          "gap_mes": 0.0,
          "gap_mes_mtd": 0.0,
          "jul": 0.0,
          "ago": 0.0,
          "sete": 0.0,
          "outr": 0.0,
          "nov": 0.0,
          "dez": 0.0,
          "jan": 0.0,
          "fev": 0.0,
          "mar": 0.0,
          "abr": 0.0,
          "mai": 0.0,
          "jun": 0.0
        }

      ],
      total: [
        {
          "nome_dealer": "Calculando...",
          "qnt_dealer": 0,
          "budget": 0.0,
          "budget_mtd": 0.0,
          "valor": 0.0,
          "gap_mes": 0.0,
          "gap_mes_mtd": 0.0
        }
      ]
    };

    this.budgetTab2 = 0;
    this.budgetTab2_mtd = 0;
    this.realizadoTab2 = 0;
    this.gap_mes = 0;
    this.gap_mes_mtd = 0;
    this.jul = 0;
    this.ago = 0;
    this.sete = 0;
    this.outr = 0;
    this.nov = 0;
    this.dez = 0;
    this.jan = 0;
    this.fev = 0;
    this.mar = 0;
    this.abr = 0;
    this.mai = 0;
    this.jun = 0;
  }

  onKey(event) {
    this.filtroconsolidado = false;
    this.filtropecas = true;
    this.filtroroupas = true;
    this.filtroacessorios = true;
    this.tipo = [1, 2, 3];
    this.setaValorData(event);
    this.calculando()
    this.calculandotab2()
    this.buscar();
    this.buscarTab2();
  }


  private TableColumns() {
    this.colsTable1 = [
      { field: 'codigo_dealer', header: 'Dealer' },
      { field: 'nome_dealer', header: 'commercial.commercialAtacado.abaPrincipal.nome' },
      { field: 'budget', header: 'Budget Full', type: this.currency, arg1: ' ' },
      { field: 'budget_ytd', header: 'Budget YTD', type: this.currency, arg1: ' ' },
      { field: 'realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ' },
      { field: 'pendente', header: 'commercial.commercialAtacado.abaPrincipal.pendente_full', type: this.currency, arg1: ' ' },
      { field: 'pendente_ytd', header: 'commercial.commercialAtacado.abaPrincipal.pendente_ytd', type: this.currency, arg1: ' ' }
    ];
    this.colsTable2 = [
      { field: 'codigo_dealer', header: 'Dealer' },
      { field: 'nome_dealer', header: 'commercial.commercialAtacado.abaPrincipal.nome' },
      { field: 'budget', header: 'Budget Full', type: this.currency, arg1: ' ' },
      { field: 'budget_mtd', header: 'Budget MTD', type: this.currency, arg1: ' ' },
      { field: 'realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ' },
      { field: 'gap_mes', header: 'commercial.commercialAtacado.abaPrincipal.gapMes_full', type: this.currency, arg1: ' ' },
      { field: 'gap_mes_mtd', header: 'commercial.commercialAtacado.abaPrincipal.gapMes_mtd', type: this.currency, arg1: ' ' }
    ];
    this.colsQuarters = [
      { field: 'codigo_dealer', header: 'Dealer' },
      { field: 'q1_previsao', header: 'Q1', type: this.currency, arg1: ' ' },
      { field: 'q1_realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ', width: '6rem' },
      { field: 'q1_percentual', header: '%', type: this.percent, arg1: '1.0-0' },
      { field: 'q2_previsao', header: 'Q2', type: this.currency, arg1: ' ' },
      { field: 'q2_realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ', width: '6rem' },
      { field: 'q2_percentual', header: '%', type: this.percent, arg1: '1.0-0' },
      { field: 'q3_previsao', header: 'Q3', type: this.currency, arg1: ' ' },
      { field: 'q3_realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ', width: '6rem' },
      { field: 'q3_percentual', header: '%', type: this.percent, arg1: '1.0-0' },
      { field: 'q4_previsao', header: 'Q4', type: this.currency, arg1: ' ' },
      { field: 'q4_realizado', header: 'commercial.commercialAtacado.abaPrincipal.realizado', type: this.currency, arg1: ' ', width: '6rem' },
      { field: 'q4_percentual', header: '%', type: this.percent, arg1: '1.0-0' }
    ];
    if (this.marcas === 'Triumph') {
      this.colsHistory = [
        { field: 'codigo_dealer', header: 'Dealer' },
        { field: 'jul', header: 'commercial.commercialAtacado.abaHistorico.meses.jul', type: this.currency, arg1: ' ' },
        { field: 'ago', header: 'commercial.commercialAtacado.abaHistorico.meses.ago', type: this.currency, arg1: ' ' },
        { field: 'sete', header: 'commercial.commercialAtacado.abaHistorico.meses.set', type: this.currency, arg1: ' ' },
        { field: 'outr', header: 'commercial.commercialAtacado.abaHistorico.meses.out', type: this.currency, arg1: ' ' },
        { field: 'nov', header: 'commercial.commercialAtacado.abaHistorico.meses.nov', type: this.currency, arg1: ' ' },
        { field: 'dez', header: 'commercial.commercialAtacado.abaHistorico.meses.dez', type: this.currency, arg1: ' ' },
        { field: 'jan', header: 'commercial.commercialAtacado.abaHistorico.meses.jan', type: this.currency, arg1: ' ' },
        { field: 'fev', header: 'commercial.commercialAtacado.abaHistorico.meses.fev', type: this.currency, arg1: ' ' },
        { field: 'mar', header: 'commercial.commercialAtacado.abaHistorico.meses.mar', type: this.currency, arg1: ' ' },
        { field: 'abr', header: 'commercial.commercialAtacado.abaHistorico.meses.abr', type: this.currency, arg1: ' ' },
        { field: 'mai', header: 'commercial.commercialAtacado.abaHistorico.meses.mai', type: this.currency, arg1: ' ' },
        { field: 'jun', header: 'commercial.commercialAtacado.abaHistorico.meses.jun', type: this.currency, arg1: ' ' }
      ];
    } else {
      this.colsHistory = [
        { field: 'codigo_dealer', header: 'Dealer' },
        { field: 'jan', header: 'commercial.commercialAtacado.abaHistorico.meses.jan', type: this.currency, arg1: ' ' },
        { field: 'fev', header: 'commercial.commercialAtacado.abaHistorico.meses.fev', type: this.currency, arg1: ' ' },
        { field: 'mar', header: 'commercial.commercialAtacado.abaHistorico.meses.mar', type: this.currency, arg1: ' ' },
        { field: 'abr', header: 'commercial.commercialAtacado.abaHistorico.meses.abr', type: this.currency, arg1: ' ' },
        { field: 'mai', header: 'commercial.commercialAtacado.abaHistorico.meses.mai', type: this.currency, arg1: ' ' },
        { field: 'jun', header: 'commercial.commercialAtacado.abaHistorico.meses.jun', type: this.currency, arg1: ' ' },
        { field: 'jul', header: 'commercial.commercialAtacado.abaHistorico.meses.jul', type: this.currency, arg1: ' ' },
        { field: 'ago', header: 'commercial.commercialAtacado.abaHistorico.meses.ago', type: this.currency, arg1: ' ' },
        { field: 'sete', header: 'commercial.commercialAtacado.abaHistorico.meses.set', type: this.currency, arg1: ' ' },
        { field: 'outr', header: 'commercial.commercialAtacado.abaHistorico.meses.out', type: this.currency, arg1: ' ' },
        { field: 'nov', header: 'commercial.commercialAtacado.abaHistorico.meses.nov', type: this.currency, arg1: ' ' },
        { field: 'dez', header: 'commercial.commercialAtacado.abaHistorico.meses.dez', type: this.currency, arg1: ' ' }
      ];
    }
  }
}
